module.exports = __webpack_public_path__ + "img/GAME_CATCHTHEFISH2.66936672.jpg";